import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Device } from '@ionic-native/device/ngx';
import { Platform } from '@ionic/angular';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceUuidInterceptor implements HttpInterceptor {
  constructor(
    private device: Device,
    private platform: Platform
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    // Only add device UUID for authenticated requests
    if (req.headers.has('Authorization')) {
      const isNativePlatform = this.platform.is('cordova') || this.platform.is('capacitor');
      
      // Get UUID only if we're on a native platform
      const uuid = isNativePlatform ? this.device.uuid : null;
      
      // Always add uuid for /api/users/me and /api/v2/jobs/available-shifts, but only if we have one
      const isTargetedPath = /\/(api\/users\/me|api\/v2\/jobs\/available-shifts)/.test(req.url);
      
      // Only add the header if we have a UUID
      if (uuid && (isTargetedPath || isNativePlatform)) {
        req = req.clone({
          headers: req.headers.set('x-device-uuid', uuid)
        });
      }
    }

    return next.handle(req);
  }
}